export class SharePreferencesPanelLinks {
    static cluster_members =
        "https://help.collabwriting.com/en/articles/7729184-how-to-use-topic-access-roles";
    static topic_members =
        "https://help.collabwriting.com/en/articles/7729184-how-to-use-topic-access-roles";
    static general_access =
        "https://collabwriting.notion.site/How-to-use-Topic-Access-Roles-e8bb57de3d53439ea98a8076782c998d";
}
